<template>
  <div>
    <input
      v-if="$attrs.type !== 'text'"
      v-bind="$attrs"
      ref="chatInput"
      class="chat-input"
      required
      :value="value"
      @input="handleFormInput"
      @invalid="$emit('invalid', $event)"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
    >
    <textarea
      v-else
      v-bind="$attrs"
      ref="chatInput"
      class="chat-input"
      required
      :rows="1"
      :value="value"
      @keypress.enter="handleEnter"
      @input="handleFormInput"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
    />
  </div>
</template>

<script>
// @flow

export default {
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  mounted (): void {
    // autofocus when rendered
    this.$nextTick(() => this.$refs.chatInput.focus())
  },
  methods: {
    handleEnter (event: any): void {
      this.$emit('submit', event)
    },
    handleFormInput (event: any): void {
      this.$emit('input', event.target.value)
      event.target.setCustomValidity('')
      if (this.$refs.chatInput.tagName === 'TEXTAREA') this.setTextareaHeight(event)
    },
    setTextareaHeight (event: any): void {
      this.$refs.chatInput.style.height = 'auto'
      this.$nextTick(() => {
        const { scrollHeight } = event.target
        let finalHeight = `${scrollHeight}px`
        if (scrollHeight >= 84) finalHeight = '84px'
        this.$refs.chatInput.style.height = finalHeight
      })
    }
  }
}
</script>
